import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData, postData, putData, deleteData } from "../../../../services/apiEndpoints";
import toast from "react-hot-toast";

export const fetchCashFlowsThunk = createAsyncThunk(
  "cashFlow/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getData("/finance/cashflow/getall", params);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to fetch cash flows");
    }
  }
);

export const createCashFlowThunk = createAsyncThunk(
  "cashFlow/create",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await postData("/finance/cashflow/create", data);
      if (response.success) {
        toast.success("Voucher created successfully");
        dispatch(fetchCashFlowsThunk({ page: 1, limit: 10 }));
      } else {
        toast.error(response.message || "Failed to create");
      }
      return response;
    } catch (error) {
      toast.error("Failed to create voucher");
      return rejectWithValue(error?.response?.data?.message || "Failed to create");
    }
  }
);

export const updateCashFlowThunk = createAsyncThunk(
  "cashFlow/update",
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await putData(`/finance/cashflow/update/${id}`, data);
      if (response.success) {
        toast.success("Voucher updated successfully");
        dispatch(fetchCashFlowsThunk({ page: 1, limit: 10 }));
      } else {
        toast.error(response.message || "Failed to update");
      }
      return response;
    } catch (error) {
      toast.error("Failed to update voucher");
      return rejectWithValue(error?.response?.data?.message || "Failed to update");
    }
  }
);

export const deleteCashFlowThunk = createAsyncThunk(
  "cashFlow/delete",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteData(`/finance/cashflow/delete/${id}`);
      if (response.success) {
        toast.success("Voucher deleted successfully");
        dispatch(fetchCashFlowsThunk({ page: 1, limit: 10 }));
      }
      return { id, ...response };
    } catch (error) {
      toast.error("Failed to delete voucher");
      return rejectWithValue(error?.response?.data?.message || "Failed to delete");
    }
  }
);
